/**
 * THE CASE'S COVER (2026-09-23, Andre): the firm's own people at work, the way
 * Harborlight's first cover was a vet examining a dog, never an empty room.
 * One painting per case (Codex, Step H), registered whole at 3:2.
 */
export const CASE_COVER: Readonly<Record<string, string>> = {
  "alderwick-health": "ink.card.case.alderwick-health",
  brindlemere: "ink.card.case.brindlemere",
  cawthorne: "ink.card.case.cawthorne",
  cranemoor: "ink.card.case.cranemoor",
  drayvale: "ink.card.case.drayvale",
  ellerby: "ink.card.case.ellerby",
  halverford: "ink.card.case.halverford",
  harborlight: "ink.card.case.harborlight",
  "kesslow-precision": "ink.card.case.kesslow-precision",
  larkmead: "ink.card.case.larkmead",
  marrowfield: "ink.card.case.marrowfield",
  millgate: "ink.card.case.millgate",
  "ninebark-engineering": "ink.card.case.ninebark-engineering",
  "ostrander-freight": "ink.card.case.ostrander-freight",
  ryecote: "ink.card.case.ryecote",
  "sedgewell-imaging": "ink.card.case.sedgewell-imaging",
  stanwick: "ink.card.case.stanwick",
  thirlwell: "ink.card.case.thirlwell",
  tollemarsh: "ink.card.case.tollemarsh",
  umberton: "ink.card.case.umberton",
  wrenhall: "ink.card.case.wrenhall",
};
/** A case without a painting of its own yet: the generic practice desk. */
export const DEFAULT_COVER = "ink.card.practice.desk";
export function coverSymbolFor(slug: string): string {
  return CASE_COVER[slug] ?? DEFAULT_COVER;
}

/**
 * THE FOCUS CARD'S PAINTING, by the skill the focus is about (2026-09-23,
 * Andre): one image per skill, keyed by the skill's word so the coverage gate
 * reads this map like the case map. The practice card draws one of six
 * generic working scenes, chosen by the brief so the same exercise always
 * wears the same picture.
 */
export const FOCUS_COVER: Readonly<Record<string, string>> = {
  structure: "ink.card.skill.structure",
  quantitative: "ink.card.skill.quantitative",
  judgment: "ink.card.skill.judgment",
  communication: "ink.card.skill.communication",
  "ambiguity-tolerance": "ink.card.skill.ambiguity-tolerance",
  calibration: "ink.card.skill.calibration",
};
/** With no focus yet, the paper shows the window: someone about to decide what to work on. */
export const FOCUS_NONE_COVER = "ink.card.practice.window";
export const PRACTICE_COVER: Readonly<Record<string, string>> = {
  desk: "ink.card.practice.desk",
  whiteboard: "ink.card.practice.whiteboard",
  table: "ink.card.practice.table",
  call: "ink.card.practice.call",
  notes: "ink.card.practice.notes",
  window: "ink.card.practice.window",
};
export function focusCoverFor(dimension: string | null): string {
  if (dimension === null) return FOCUS_NONE_COVER;
  return FOCUS_COVER[dimension.toLowerCase().replaceAll("_", "-")] ?? FOCUS_NONE_COVER;
}
export function practiceCoverFor(briefId: string | null): string {
  if (briefId === null) return PRACTICE_COVER["desk"] ?? DEFAULT_COVER;
  const keys = Object.keys(PRACTICE_COVER);
  let h = 0;
  for (const ch of briefId) h = (h * 31 + ch.charCodeAt(0)) % 100_003;
  const key = keys[h % keys.length];
  return (key === undefined ? undefined : PRACTICE_COVER[key]) ?? DEFAULT_COVER;
}
